export default __webpack_public_path__ + "static/media/producto-sin-imagen.3b1d0a2a.png";